import { HomeIcon, HistoryIcon, MessageIcon, VideoIcon, TrophyIcon } from '../navIcons';

/**
 * The student's five destinations, in tab order. One list for both navs — the
 * floating pill on phones (BottomNavBar) and the sidebar from 1024px
 * (StudentDesktopNav) — so they can never disagree on a route or an icon.
 *
 * Classement is always present: on a coach's free plan the page itself
 * explains it is a paid feature (StudentRankings).
 */
export const getStudentNavItems = (t) => [
  { to: '/student/dashboard', icon: HomeIcon, id: 'home', label: t('nav.home') },
  { to: '/student/history', icon: HistoryIcon, id: 'planning', label: t('nav.planning') },
  { to: '/chat', icon: MessageIcon, id: 'messages', label: t('nav.messages') },
  { to: '/student/videos', icon: VideoIcon, id: 'video_library', label: t('nav.video_library') },
  { to: '/student/rankings', icon: TrophyIcon, id: 'rankings', label: t('nav.rankings') },
];
